import { RootState } from "store";

export const selectContent = (state:RootState) => state.aiChat.content;
export const selectTranslations = (state:RootState) => state.aiChat.translations;
